import { useTheme } from '@material-ui/core/styles';
import { CardProps } from '../lib/types';
import { Card } from '../core/card';
import { Entity } from '@backstage/catalog-model';
import { FC } from 'react';
import { buildVariantCardProps } from './lib/build-variant-card-props';

// Generic props for the base card
export type BaseEntityCardProps = CardProps & {
  entity?: Entity;
  // Function to resolve the action route (e.g., useEntityRoute, useTechDocsLink)
  getActionRoute: (entity?: Entity) => string | undefined;
  defaultActionLabel: string;
};

export const BaseEntityCard: FC<BaseEntityCardProps> = props => {
  const theme = useTheme();
  const {
    entity,
    actionRoute,
    variant,
    actionable,
    withoutTheme,
    getActionRoute,
    defaultActionLabel,
    ...rest
  } = props;

  const cardProps = {
    ...rest,
    ...buildVariantCardProps({
      entity,
      actionRoute,
      actionLabel: props.actionLabel,
      variant,
      actionable,
      withoutTheme,
      resolvedActionRoute: getActionRoute(entity),
      defaultActionLabel,
    }),
  };

  return (
    <Card.Root {...cardProps}>
      <Card.Card>
        <Card.Actionable
          cardProps={{
            ...cardProps,
            actionable: cardProps.actionable ?? false,
          }}
          style={{ padding: theme.spacing(0) }}
        >
          <Card.Title />
          <Card.Content />
        </Card.Actionable>
        <Card.Actions />
      </Card.Card>
    </Card.Root>
  );
};
